import React from 'react';
import PropTypes from 'prop-types';

import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { API_HOST, HTTP_PROTOCOL } from '../../config';

class CustomerFreightProviderSlider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            formInputs: {
                fee: 0,
                mu_percentage_fuel_levy: 0,
                client_mu_1_minimum_values: 0,
                packed_status: 'original',
            },
        };

        this.submitHandler = this.submitHandler.bind(this);
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        pkAutoId: PropTypes.number,
        quote: PropTypes.object.isRequired,
        toggleSlider: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { isOpen, quote } = nextProps;

        if (!this.props.isOpen && isOpen) {
            let formInputs= {
                pk_auto_id: this.props.pkAutoId,
                fee: 0,
                etd: 3,
                mu_percentage_fuel_levy: 0,
                client_mu_1_minimum_values: 0,
                packed_status: 'original'
            };
            if (quote) {
                formInputs = {
                    quote_id: quote.cost_id,
                    freight_provider: quote.fp_name,
                    service_name: quote.service_name,
                    fee: quote.cost_dollar,
                    etd: quote.eta.split(' ')[0],
                    mu_percentage_fuel_levy: quote.mu_percentage_fuel_levy,
                    client_mu_1_minimum_values:  Number(quote.cost_dollar * (1 + Number(quote.mu_percentage_fuel_levy))).toFixed(3),                    
                    packed_status: quote.packed_status
                };
            }
            this.setState({ formInputs });
        }
    }

    notify = (text) => {
        toast(text);
    };

    onInputChange(event) {
        const { formInputs } = this.state;
        const target = event.target;
        const value = target.value;
        const name = target.name;

        formInputs[name] = value;
        if (name === 'etd') {
            formInputs[name] = Number(value);
        }
        if (name === 'fee' || name === 'mu_percentage_fuel_levy') {
            formInputs[name] = Number(value);
            formInputs['client_mu_1_minimum_values'] = Number(formInputs['fee'] * (1 + Number(formInputs['mu_percentage_fuel_levy']))).toFixed(3); 
        }
        this.setState({formInputs});
    }

    submitHandler(e) {
        e.preventDefault();
        const { formInputs } = this.state;
        const { quote } = this.props;

        if (!quote && !formInputs['pk_auto_id']) {
            this.notify('pk_auto_id is not valid');
            return;
        }

        const token = localStorage.getItem('token');
        
        const options = {
            method: quote ? 'put' : 'post',
            url: `${HTTP_PROTOCOL}://${API_HOST}/pricing/${quote ? 'edit' : 'add'}/`,
            headers: {'Authorization': 'JWT ' + token },
            data: { ...formInputs }
        };
        axios(options)
            .then(() => {
                this.notify('Successfully Done!');
                this.props.onSubmit();
            })
            .catch((error) => {
                this.notify('Failed: ' + error);
            });

    }

    render() {
        const { isOpen, toggleSlider } = this.props;
        const { formInputs } = this.state;    

        return (
            <SlidingPane
                className='customer-freight-provider-slider'
                overlayClassName='customer-freight-provider-slider-overlay'
                isOpen={isOpen}
                title='Custom Freight Provider Slider'
                subtitle='Form View'
                onRequestClose={toggleSlider}>
                <div className="slider-content">
                    <form onSubmit={this.submitHandler}>
                        <label>
                            <p>Freight Provider</p>
                            <input
                                className="form-control"
                                type="text"
                                name="freight_provider"
                                value={formInputs['freight_provider']}
                                required
                                onChange={(e) => this.onInputChange(e)}
                            />
                        </label>
                        <label>
                            <p>Service Name</p>
                            <input
                                className="form-control"
                                type="text"
                                name="service_name"
                                value={formInputs['service_name']}
                                onChange={(e) => this.onInputChange(e)}
                            />
                        </label>
                        <label>
                            <p>Estimated days</p>
                            <input 
                                className="form-control"
                                required
                                step="0.1"
                                type="number"
                                name="etd"
                                value={formInputs['etd']}
                                onChange={(e) => this.onInputChange(e)}
                            />
                        </label>
                        <label>
                            <p>Price</p>
                            <input 
                                className="form-control"
                                required
                                step="0.01"
                                type="number"
                                name="fee"
                                value={formInputs['fee']}
                                onChange={(e) => this.onInputChange(e)}
                            />
                        </label>
                        <label>
                            <p>Fuel Levy Percent</p>
                            <input 
                                className="form-control"
                                required
                                step="0.01"
                                type="number"
                                min={0}
                                max={1}
                                name="mu_percentage_fuel_levy"
                                value={formInputs['mu_percentage_fuel_levy']}
                                onChange={(e) => this.onInputChange(e)}
                            />
                        </label>
                        <label>
                            <p>Total Cost inc. Fuel ex GST</p>
                            <input 
                                className="form-control"
                                required
                                disabled
                                step="0.01"
                                type="number"
                                name="client_mu_1_minimum_values"
                                value={formInputs['client_mu_1_minimum_values']}
                            />
                        </label>
                        <label>
                            <p>Packed Status</p>
                            <select
                                className="form-control"
                                name="packed_status"
                                value={formInputs['packed_status']}
                                onChange={(e) => this.onInputChange(e)}
                            >
                                <option value='original'>Send As</option>
                                <option value='auto'>Auto Repack</option>
                                <option value='manual'>Manual Repack</option>
                                <option value='scanned'>Actual Packed / Packing Scans</option>
                            </select>
                        </label>
                        <label>
                            <Button type="submit primary" color="primary">Submit</Button>
                            <Button color="danger" onClick={toggleSlider}>Cancel</Button>
                        </label>
                    </form>
                </div>

                
            </SlidingPane>
        );
    }
}

export default CustomerFreightProviderSlider;



// WEBPACK FOOTER //
// ./src/components/Sliders/CustomerFreightProviderSlider.js